import CoreService from '@/core/core.service.js';

export default {
  components: {
  },
  data() {
    return {
      visible: false,
      visible2: false,
      tableList: [],
      pdfList: [
        {name: '关于组织开展2025年上半年农产品加工业统计调查系统填报工作的通知', url: 'https://rongxin-pub.oss-cn-beijing.aliyuncs.com/document/202501/%E5%85%B3%E4%BA%8E%E7%BB%84%E7%BB%87%E5%BC%80%E5%B1%952025%E5%B9%B4%E4%B8%8A%E5%8D%8A%E5%B9%B4%E5%86%9C%E4%BA%A7%E5%93%81%E5%8A%A0%E5%B7%A5%E4%B8%9A%E7%BB%9F%E8%AE%A1%E8%B0%83%E6%9F%A5%E7%B3%BB%E7%BB%9F%E5%A1%AB%E6%8A%A5%E5%B7%A5%E4%BD%9C%E7%9A%84%E9%80%9A%E7%9F%A5.pdf'},
        {name: '关于组织开展2024年全省农产品加工业统计调查系统填报工作的通知', url: 'https://rongxin-pub.oss-cn-beijing.aliyuncs.com/document/202501/%E5%85%B3%E4%BA%8E%E7%BB%84%E7%BB%87%E5%BC%80%E5%B1%95%E5%85%A8%E7%9C%81%E5%86%9C%E4%BA%A7%E5%93%81%E5%8A%A0%E5%B7%A5%E4%B8%9A%E7%BB%9F%E8%AE%A1%E8%B0%83%E6%9F%A5%E7%B3%BB%E7%BB%9F%E5%A1%AB%E6%8A%A5%E5%B7%A5%E4%BD%9C%E7%9A%84%E9%80%9A%E7%9F%A5.pdf'},
        {name: '黑龙江省支持农产品加工企业发展相关政策汇编', url: 'https://rongxin-pub.oss-cn-beijing.aliyuncs.com/document/202407/%E9%BB%91%E9%BE%99%E6%B1%9F%E7%9C%81%E6%94%AF%E6%8C%81%E5%86%9C%E4%BA%A7%E5%93%81%E5%8A%A0%E5%B7%A5%E4%BC%81%E4%B8%9A%E5%8F%91%E5%B1%95%E7%9B%B8%E5%85%B3%E6%94%BF%E7%AD%96%E6%B1%87%E7%BC%96.pdf'},
        {name: '黑粮产业联〔2023〕92号 关于印发黑龙江省农产品精深加工流动资金贷款贴息项目实施方案的通知', url: 'https://rongxin-pub.oss-cn-beijing.aliyuncs.com/document/202407/%E9%BB%91%E7%B2%AE%E4%BA%A7%E4%B8%9A%E8%81%94%E3%80%942023%E3%80%9592%E5%8F%B7%20%E5%85%B3%E4%BA%8E%E5%8D%B0%E5%8F%91%E9%BB%91%E9%BE%99%E6%B1%9F%E7%9C%81%E5%86%9C%E4%BA%A7%E5%93%81%E7%B2%BE%E6%B7%B1%E5%8A%A0%E5%B7%A5%E6%B5%81%E5%8A%A8%E8%B5%84%E9%87%91%E8%B4%B7%E6%AC%BE%E8%B4%B4%E6%81%AF%E9%A1%B9%E7%9B%AE%E5%AE%9E%E6%96%BD%E6%96%B9%E6%A1%88%E7%9A%84%E9%80%9A%E7%9F%A5.pdf'},
        {name: '黑农厅联发〔2023〕357号 2023年省级以上加工类农业产业化龙头企业整合扩张中间服务费用补贴项目实施方案', url: 'https://rongxin-pub.oss-cn-beijing.aliyuncs.com/document/202407/%E9%BB%91%E5%86%9C%E5%8E%85%E8%81%94%E5%8F%91%E3%80%942023%E3%80%95357%E5%8F%B7%202023%E5%B9%B4%E7%9C%81%E7%BA%A7%E4%BB%A5%E4%B8%8A%E5%8A%A0%E5%B7%A5%E7%B1%BB%E5%86%9C%E4%B8%9A%E4%BA%A7%E4%B8%9A%E5%8C%96%E9%BE%99%E5%A4%B4%E4%BC%81%E4%B8%9A%E6%95%B4%E5%90%88%E6%89%A9%E5%BC%A0%E4%B8%AD%E9%97%B4%E6%9C%8D%E5%8A%A1%E8%B4%B9%E7%94%A8%E8%A1%A5%E8%B4%B4%E9%A1%B9%E7%9B%AE%E5%AE%9E%E6%96%BD%E6%96%B9%E6%A1%88.pdf'},
        {name: '关于印发黑龙江省加快推进农产品加工业高质量发展三年行动计划（2023-2025年）的通知', url: 'https://rongxin-pub.oss-cn-beijing.aliyuncs.com/document/202305/%E5%85%B3%E4%BA%8E%E5%8D%B0%E5%8F%91%E9%BB%91%E9%BE%99%E6%B1%9F%E7%9C%81%E5%8A%A0%E5%BF%AB%E6%8E%A8%E8%BF%9B%E5%86%9C%E4%BA%A7%E5%93%81%E5%8A%A0%E5%B7%A5%E4%B8%9A%E9%AB%98%E8%B4%A8%E9%87%8F%E5%8F%91%E5%B1%95%E4%B8%89%E5%B9%B4%E8%A1%8C%E5%8A%A8%E8%AE%A1%E5%88%92%EF%BC%882023-2025%E5%B9%B4%EF%BC%89%E7%9A%84%E9%80%9A%E7%9F%A5.pdf'},
        {name: '关于印发黑龙江省支持农产品精深加工业高质量发展若干政策措施', url: 'https://rongxin-pub.oss-cn-beijing.aliyuncs.com/document/202305/%E5%85%B3%E4%BA%8E%E5%8D%B0%E5%8F%91%E9%BB%91%E9%BE%99%E6%B1%9F%E7%9C%81%E6%94%AF%E6%8C%81%E5%86%9C%E4%BA%A7%E5%93%81%E7%B2%BE%E6%B7%B1%E5%8A%A0%E5%B7%A5%E4%B8%9A%E9%AB%98%E8%B4%A8%E9%87%8F%E5%8F%91%E5%B1%95%E8%8B%A5%E5%B9%B2%E6%94%BF%E7%AD%96%E6%8E%AA%E6%96%BD.pdf'},
        {name: '黑粮农联办函〔2024〕6号 关于组织开展黑龙江省农产品加工业统计调查工作的通知', url: 'https://rongxin-pub.oss-cn-beijing.aliyuncs.com/document/202305/%E6%94%BF%E7%AD%96%E6%96%87%E4%BB%B6.pdf'}
      ]
    };
  },
  created() {
    this.getBackRecord();
  },
  methods: {
    getBackRecord() {
      CoreService.getBackRecord().then(res => {
        this.tableList = res || [];
      });
    },
    pageSkip (url) {
      this.$router.push(url);
    },
    lookBackRecord () {
      console.log(999);
      this.visible = true;
    },
    close () {
      this.visible = false;
    },
    lookPdf (type) {
      if (type === 1) {
        window.open('https://rongxin-pub.oss-cn-beijing.aliyuncs.com/document/202305/%E6%94%BF%E7%AD%96%E6%96%87%E4%BB%B6.pdf');
      } else if (type === 2) {
        window.open('https://rongxin-pub.oss-cn-beijing.aliyuncs.com/document/202305/%E9%BB%91%E9%BE%99%E6%B1%9F%E7%9C%81%E5%86%9C%E4%BA%A7%E5%93%81%E5%8A%A0%E5%B7%A5%E4%B8%9A%E5%B9%B4%E5%BA%A6%E7%BB%9F%E8%AE%A1%E8%B0%83%E6%9F%A5%E7%B3%BB%E7%BB%9F%E4%BC%81%E4%B8%9A%E5%A1%AB%E6%8A%A5%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf');
      }
    },
    lookPdf2 (url) {
      window.open(url);
    }
  }
};
